var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showSettings)?_c('f7-link',{attrs:{"icon":"far fa-cog"},on:{"click":_vm.goToSettings}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }